export const INGEST_METHOD_TYPES = ['dashboard', 'download_url', 'remote_url', 'api_put'] as const;
export type IngestMethodType = typeof INGEST_METHOD_TYPES[number];

export const MEDIA_SOURCE_TYPES = ['uploaded_source'] as const;
export type MediaSourceType = typeof MEDIA_SOURCE_TYPES[number];

export const UPLOAD_ITEM_STATUSES = [
  'pending',
  'creating',
  'uploading',
  'processing',
  'ready',
  'error',
  'cancelled',
] as const;
export type UploadItemStatus = typeof UPLOAD_ITEM_STATUSES[number];

export const JOB_STATUSES = ['queued', 'started', 'completed', 'failed', 'canceled'] as const;
export type JobStatus = typeof JOB_STATUSES[number];

/** Job statuses that mean work is still running (percent is meaningful). */
export const ACTIVE_JOB_STATUSES: readonly JobStatus[] = ['queued', 'started'];
